import clsx from 'clsx';
import React from 'react';

interface TagProps {
  className?: string;
  name: string;
}

const Tag = ({ name, className }: TagProps) => {
  return (
    <span
      className={clsx(
        'tw-bg-primary-red tw-rounded-28 tw-px-12 tw-py-2 tw-ml-auto tw-text-white \
        tw-text-body-sm tw-font-sans tw-whitespace-nowrap tw-hidden sm:tw-text-xs xs:tw-block',
        className
      )}
    >
      {name}
    </span>
  );
};

export default Tag;
